import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Button } from '@material-ui/core';
import { Cached } from '@material-ui/icons';

const S = {
  Button: styled(Button)`
    height: 40px;
    min-height: 40px;
    margin-right: auto;
    color: ${({ theme }) => theme.palette.grey[600]};
    font-size: ${({ theme }) => theme.typography.pxToRem(15)};
  `,
  Cached: styled(Cached)`
    margin-right: 8px;
    color: ${({ theme }) => theme.palette.grey[600]};
    font-size: 1.25rem;
  `,
};

const ContactSwapButton = ({
  children, className, values, onClick,
}) => {
  const handleClick = useCallback(() => {
    onClick({
      ...values,
      primaryGuardian: values.secondaryGuardian,
      secondaryGuardian: values.primaryGuardian,
    });
  }, [values, onClick]);

  return (
    <S.Button className={className} type="button" onClick={handleClick}>
      <S.Cached />
      {children}
    </S.Button>
  );
};

ContactSwapButton.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  values: PropTypes.shape({
    primaryGuardian: PropTypes.shape({
      name: PropTypes.string,
      relationship: PropTypes.string,
      phoneNumber: PropTypes.string,
      email: PropTypes.string,
    }),
    secondaryGuardian: PropTypes.shape({
      name: PropTypes.string,
      relationship: PropTypes.string,
      phoneNumber: PropTypes.string,
      email: PropTypes.string,
    }),
  }).isRequired,
  onClick: PropTypes.func.isRequired,
};

ContactSwapButton.defaultProps = {
  className: undefined,
};

export default ContactSwapButton;
